/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum VccCredentialsV2OrderValue {
    BrandAndMarket = 'BrandAndMarket',
    Description = 'Description',
    CardProvider = 'CardProvider'
}

export function VccCredentialsV2OrderValueFromJSON(json: any): VccCredentialsV2OrderValue {
    return VccCredentialsV2OrderValueFromJSONTyped(json, false);
}

export function VccCredentialsV2OrderValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsV2OrderValue {
    return json as VccCredentialsV2OrderValue;
}

export function VccCredentialsV2OrderValueToJSON(value?: VccCredentialsV2OrderValue | null): any {
    return value as any;
}

